import Gardener from 'scoreboard/components/gardener'
import { Transform } from 'stream'

var BriefingsGardener = Gardener.extend({

	_treeOptions: function() {
		var treeOptions = Gardener.prototype._treeOptions.apply(this, arguments)
		treeOptions.accessors = { icon: 'icon' }
		treeOptions.stream = treeOptions.stream.pipe(this._iconTransform())
		return treeOptions
	},

	_iconTransform: function() {
		var self = this
		var icons = new Transform({ objectMode: true })
		icons._transform = function (node, enc, next) {
			node.icon = self._getIcon(node.type)
			this.push(node)
			next()
		}
		return icons
	},

	_getIcon: function(type) {
		return type === 'folder' ? 'folder' : 'briefings'
	},

	_copyDomainObject: function(options, ids) {
		// If we just copied a slide, the gardener should have no interest in
		// showing it #28793
		if (options.domainType == 'slide') return

		Gardener.prototype._copyDomainObject.apply(this, arguments)
	},

	_addDomainObject: function(model, relativeId) {
		if (!this.interested(model)) return

		model.set('icon', this._getIcon(model.get('type')))
		Gardener.prototype._addDomainObject.call(this, model, relativeId)
	}

})

export default BriefingsGardener

BriefingsGardener.__filename__ = 'briefings/briefings-gardener.js'
